import React from 'react';
import classnames from 'classnames';

import styles from './UI.module.css';

interface ButtonProps {
  onClick?: Function;
  value: string;
  invert?: boolean;
  className?: string;
  submit?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  value,
  invert,
  className,
  submit,
}) => {
  return (
    <input
      type={submit ? 'submit' : 'button'}
      value={value}
      onClick={() => !!onClick && onClick()}
      className={classnames(
        styles.button,
        {
          [styles.buttonInverted]: invert,
        },
        className
      )}
    />
  );
};

export default Button;
